// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-badge,
.slc-badge,
.registration-badge {
  display: flex;
  flex-wrap: wrap;
}

ion-list,
ion-list.list-ios {
  background: var(--background);
}

.card-badge.horizontal ion-col {
  border: 0.1rem solid #cacaca;
  margin: 0.5rem;
  max-width: fit-content;
  padding: 0;
}
.card-badge.horizontal ion-col .badge {
  flex: none;
  font-family: "avenir next", sans-serif;
  margin: 0rem auto;
  position: relative;
  height: 2.16in;
  width: 3.39in;
  background-repeat: no-repeat;
  background-size: 100% !important;
  padding: 0.6in 0.15in 0.1in;
  border: 0.1rem solid #cacaca;
  display: flex;
  flex-flow: column;
  color: black;
}
.card-badge.horizontal ion-col .badge .badge-name {
  position: relative;
  font-size: 20pt;
  line-height: 8pt;
  font-weight: 700;
  min-height: 0.55in;
  text-transform: uppercase;
  text-align: left;
  color: white;
  margin-top: 0.1in;
}
.card-badge.horizontal ion-col .badge .badge-name .first-name,
.card-badge.horizontal ion-col .badge .badge-name .last-name {
  display: block;
}
.card-badge.horizontal ion-col .badge .delegate-type {
  font-size: 10.5pt;
  font-weight: 700;
  align-items: center;
  display: flex;
  position: relative;
  color: white;
  margin-top: 0;
}
.card-badge.horizontal ion-col .badge .delegate-type .seat-icon {
  max-width: 18pt !important;
  margin-right: 3pt;
}
.card-badge.horizontal ion-col .badge .country-name {
  font-size: 10pt;
  text-transform: uppercase;
  position: absolute;
  text-align: left;
  bottom: 0.1in;
}
.card-badge.horizontal ion-col .badge .entity-id {
  display: flex;
  transform: rotateZ(-90deg);
  transform-origin: bottom right;
  font-size: 6.5pt;
  font-weight: 700;
  position: absolute;
  justify-content: center;
  right: 0.05in;
  bottom: 1.5in;
  color: white;
  background: #343434;
  padding: 2px;
}
.card-badge.horizontal ion-col .badge ngx-qrcode {
  max-width: 80px !important;
  position: absolute;
  bottom: 0;
  right: 0.25in;
  transform: rotateZ(0deg);
  display: block;
  margin: 0 auto;
}
.card-badge.horizontal ion-col .badge .order-id {
  display: flex;
  flex-flow: column;
  text-align: right;
  font-size: 9pt;
  font-weight: 700;
  position: absolute;
  top: 0.15in;
  margin: 0 0.2in;
  justify-content: space-between;
  color: white;
  right: 0;
}

.card-badge ion-col.roundtable .badge .badge-name,
.card-badge ion-col.roundtable .badge .delegate-type,
.card-badge ion-col.roundtable .badge .order-id {
  color: #343434;
}
.card-badge ion-col.roundtable .badge .country-name {
  color: white;
}

.card-badge.vertical ion-col {
  width: 2.16in;
  height: 3.35in;
}

.slc-badge ion-col {
  flex: none;
  font-family: "avenir next", sans-serif;
  margin: 0rem 0.5rem 2rem;
  position: relative;
  width: 2.75in;
  height: 7.85in;
  background-repeat: no-repeat;
  background-size: 100% !important;
  padding: 0;
  border: 0.1rem solid #cacaca;
  overflow: hidden;
  display: flex;
  flex-flow: column;
  color: black;
}
.slc-badge ion-col .badge-name {
  position: relative;
  top: 1.6in;
  font-size: 22pt;
  line-height: 14pt;
  font-weight: 700;
  margin: 0 auto;
  min-height: 0.85in;
  text-transform: uppercase;
  color: black;
}
.slc-badge ion-col .badge-name .first-name,
.slc-badge ion-col .badge-name .last-name {
  display: block;
}
.slc-badge ion-col .delegate-type {
  font-size: 1rem;
  font-weight: 700;
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  top: 2.1in;
}
.slc-badge ion-col .delegate-type .seat-icon {
  max-width: 18pt !important;
  margin-right: 3pt;
}
.slc-badge ion-col .country-name {
  font-size: 10pt;
  text-transform: uppercase;
  position: relative;
  top: 2.05in;
}
.slc-badge ion-col .entity-id {
  display: flex;
  font-size: 7.5pt;
  font-weight: 700;
  position: relative;
  top: 3.8in;
  justify-content: center;
}
.slc-badge ion-col ngx-qrcode {
  max-width: 120px !important;
  position: relative;
  top: 3.77in;
  display: block;
  margin: 0 auto;
}
.slc-badge ion-col .order-id {
  display: flex;
  flex-flow: column;
  text-align: right;
  font-size: 9pt;
  font-weight: 700;
  position: relative;
  top: 4.25in;
  margin: 0 0.2in;
  justify-content: space-between;
}

@media (prefers-color-scheme: dark) {
  .slc-badge ion-col {
    color: white;
    background-color: #d5c496;
  }
  .slc-badge ion-col .badge-name {
    color: white;
  }
}
.registration-badge ion-col .badge-name {
  font-size: 22pt;
  font-weight: 700;
  text-transform: uppercase;
}
.registration-badge ion-col ngx-qrcode {
  max-width: 180px !important;
  display: block;
  margin: 0 auto;
}
.registration-badge ion-col ion-img {
  width: 100%;
}

@media print {
  .slc-badge,
  .card-badge {
    display: block;
    flex-flow: column;
  }
  .slc-badge ion-col,
  .card-badge ion-col {
    float: none;
    page-break-after: always;
    border: none;
    padding: 0rem;
    margin: 0rem;
    display: block;
  }
  .slc-badge ion-col:last-child,
  .card-badge ion-col:last-child {
    page-break-after: auto;
  }
}
@media (prefers-color-scheme: dark) {
  .ion-color-dark {
    color: var(--ion-color-primary-contrast);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/tickets/tickets.component.scss"],"names":[],"mappings":"AAAA;;;EAGI,aAAA;EACA,eAAA;AACJ;;AAEA;;EAEI,6BAAA;AACJ;;AAEA;EACI,4BAAA;EACA,cAAA;EACA,sBAAA;EACA,UAAA;AACJ;AAAI;EACI,UAAA;EACA,sCAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,4BAAA;EACA,gCAAA;EACA,2BAAA;EACA,4BAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;AAER;AADQ;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AAGZ;AAFY;;EAEI,cAAA;AAIhB;AADQ;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AAGZ;AAFY;EACI,0BAAA;EACA,iBAAA;AAIhB;AADQ;EACI,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AAGZ;AADQ;EACI,aAAA;EACA,0BAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AAGZ;AADQ;EACI,0BAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,wBAAA;EACA,cAAA;EACA,cAAA;AAGZ;AADQ;EACI,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,8BAAA;EACA,YAAA;EACA,QAAA;AAGZ;;AAKI;;;EAGI,cAAA;AAFR;AAII;EACI,YAAA;AAFR;;AAMA;EACI,aAAA;EACA,cAAA;AAHJ;;AAMA;EACI,UAAA;EACA,sCAAA;EACA,wBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,4BAAA;EACA,gCAAA;EACA,UAAA;EACA,4BAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;AAHJ;AAII;EACI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;AAFR;AAGQ;;EAEI,cAAA;AADZ;AAII;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;AAFR;AAGQ;EACI,0BAAA;EACA,iBAAA;AADZ;AAII;EACI,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;AAFR;AAII;EACI,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;AAFR;AAII;EACI,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;AAFR;AAII;EACI,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,8BAAA;AAFR;;AAMA;EACI;IACI,YAAA;IACA,yBAAA;EAHN;EAIM;IACI,YAAA;EAFV;AACF;AAOI;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;AALR;AAOI;EACI,2BAAA;EACA,cAAA;EACA,cAAA;AALR;AAOI;EACI,WAAA;AALR;;AASA;EACI;;IAEI,cAAA;IACA,iBAAA;EANN;EAOM;;IACI,WAAA;IACA,wBAAA;IACA,YAAA;IACA,aAAA;IACA,YAAA;IACA,cAAA;EAJV;EAMM;;IACI,sBAAA;EAHV;AACF;AAOA;EACI;IACI,wCAAA;EALN;AACF","sourcesContent":[".card-badge,\n.slc-badge,\n.registration-badge {\n    display: flex;\n    flex-wrap: wrap;\n}\n\nion-list,\nion-list.list-ios {\n    background: var(--background);\n}\n\n.card-badge.horizontal ion-col {\n    border: 0.1rem solid #cacaca;\n    margin: 0.5rem;\n    max-width: fit-content;\n    padding: 0;\n    .badge {\n        flex: none;\n        font-family: \"avenir next\", sans-serif;\n        margin: 0rem auto;\n        position: relative;\n        height: 2.16in;\n        width: 3.39in;\n        background-repeat: no-repeat;\n        background-size: 100% !important;\n        padding: 0.6in .15in .1in;\n        border: .1rem solid #cacaca;\n        display: flex;\n        flex-flow: column;\n        color: black;\n        .badge-name {\n            position: relative;\n            font-size: 20pt;\n            line-height: 8pt;\n            font-weight: 700;\n            min-height: .55in;\n            text-transform: uppercase;\n            text-align: left;\n            color: white;\n            margin-top: .1in;\n            .first-name,\n            .last-name {\n                display: block;\n            }\n        }\n        .delegate-type {\n            font-size: 10.5pt;\n            font-weight: 700;\n            align-items: center;\n            display: flex;\n            position: relative;\n            color: white;\n            margin-top: 0;\n            .seat-icon {\n                max-width: 18pt !important;\n                margin-right: 3pt\n            }\n        }\n        .country-name {\n            font-size: 10pt;\n            text-transform: uppercase;\n            position: absolute;\n            text-align: left;\n            bottom: 0.1in;\n        }\n        .entity-id {\n            display: flex;\n            transform: rotateZ(-90deg);\n            transform-origin: bottom right;\n            font-size: 6.5pt;\n            font-weight: 700;\n            position: absolute;\n            justify-content: center;\n            right: .05in;\n            bottom: 1.5in;\n            color: white;\n            background: #343434;\n            padding: 2px;\n        }\n        ngx-qrcode {\n            max-width: 80px !important;\n            position: absolute;\n            bottom: 0;\n            right: .25in;\n            transform: rotateZ(0deg);\n            display: block;\n            margin: 0 auto;\n        }\n        .order-id {           \n            display: flex;\n            flex-flow: column;\n            text-align: right;\n            font-size: 9pt;\n            font-weight: 700;\n            position: absolute;\n            top: .15in;\n            margin: 0 .2in;\n            justify-content: space-between;\n            color: white;\n            right: 0;\n\n        }\n    }\n\n}\n\n.card-badge ion-col.roundtable .badge {\n    .badge-name,\n    .delegate-type,\n    .order-id {\n        color: #343434;\n    }\n    .country-name {\n        color: white;\n    }\n}\n\n.card-badge.vertical ion-col {\n    width: 2.16in;\n    height: 3.35in;\n}\n\n.slc-badge ion-col {\n    flex: none;\n    font-family: \"avenir next\", sans-serif;\n    margin: 0rem .5rem 2rem;\n    position: relative;\n    width: 2.75in;\n    height: 7.85in;\n    background-repeat: no-repeat;\n    background-size: 100% !important;\n    padding: 0;\n    border: .1rem solid #cacaca;\n    overflow: hidden;\n    display: flex;\n    flex-flow: column;\n    color: black;\n    .badge-name {\n        position: relative;\n        top: 1.6in;\n        font-size: 22pt;\n        line-height: 14pt;\n        font-weight: 700;\n        margin: 0 auto;\n        min-height: .85in;\n        text-transform: uppercase;\n        color: black;\n        .first-name,\n        .last-name {\n            display: block;\n        }\n    }\n    .delegate-type {\n        font-size: 1rem;\n        font-weight: 700;\n        align-items: center;\n        display: flex;\n        justify-content: center;\n        position: relative;\n        top: 2.1in;\n        .seat-icon {\n            max-width: 18pt !important;\n            margin-right: 3pt\n        }\n    }\n    .country-name {\n        font-size: 10pt;\n        text-transform: uppercase;\n        position: relative;\n        top: 2.05in;\n    }\n    .entity-id {\n        display: flex;\n        font-size: 7.5pt;\n        font-weight: 700;\n        position: relative;\n        top: 3.8in;\n        justify-content: center;\n    }\n    ngx-qrcode {\n        max-width: 120px !important;\n        position: relative;\n        top: 3.77in;\n        display: block;\n        margin: 0 auto;\n    }\n    .order-id {\n        display: flex;\n        flex-flow: column;\n        text-align: right;\n        font-size: 9pt;\n        font-weight: 700;\n        position: relative;\n        top: 4.25in;\n        margin: 0 .2in;\n        justify-content: space-between;\n    }\n}\n\n@media (prefers-color-scheme: dark) {\n    .slc-badge ion-col {\n        color: white;\n        background-color: #d5c496;\n        .badge-name {\n            color: white;\n        }\n    }\n}\n\n.registration-badge ion-col {\n    .badge-name {\n        font-size: 22pt;\n        font-weight: 700;\n        text-transform: uppercase;\n    }\n    ngx-qrcode {\n        max-width: 180px !important;\n        display: block;\n        margin: 0 auto;\n    }\n    ion-img {\n        width: 100%;\n    }\n}\n\n@media print {\n    .slc-badge,\n    .card-badge {\n        display: block;\n        flex-flow: column;\n        ion-col {\n            float: none;\n            page-break-after: always;\n            border: none;\n            padding: 0rem;\n            margin: 0rem;\n            display: block;\n        }\n        ion-col:last-child {\n            page-break-after: auto;\n        }\n    }\n}\n\n@media (prefers-color-scheme: dark) {\n    .ion-color-dark {\n        color: var(--ion-color-primary-contrast);\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
